export default {
	section_banner: {
		title: {
			one: 'ワンテザー',
		},
		main_title: {
			one: '独立した',
		},
		sub_title: {
			one: 'シート',
			two: 'システム',
		},
		paragraph: {
			one: 'これは、既存のドアの上に金属製のドアを取り付けるようなもので、保護層をさらに追加しますが、元のドアがすでに安全であった場合は不要または冗長になる可能性があります。',
		},
		cta_buttons: {
			one: '暗号通貨リクエスト',
			two: 'アプリをダウンロード',
		},
	},

	question_sec: {
		label: 'テザーからのZIGA',
		title: {
			one: '独立した',
			two: '座席',
			three: 'システム',
		},
		paragraph: {
			one: '時間と瞬間の間を行き来し、行き来する時間。ステップ1からステップ3まで、リズムは続く。そのアイデアが思考を刺激し、浮かんだ途端、さらに多くの思考が湧き上がってくる。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},

	online_mid: {
		label: '当社との取引',
		title: {
			one: '送信中',
			two: 'お金',
			three: '一緒に行きましょう',
		},
		paragraph: {
			one: 'JPWorldPayなら送金がシンプルかつシームレス。迅速、安全、そして信頼性の高い送金の旅を共に歩みましょう。大切な人へのサポートでも、サービスへのお支払いでも、JPWorldPayは関係者全員にとって簡単かつ効率的なプロセスを実現します。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},

	received_request_sec: {
		label: 'JPWorldPayユーザーを選択',
		title: {
			one: 'を入力してください ',
			two: 'リクエスト済み',
			three: '額',
		},
		paragraph: {
			one: 'JPWorldPayを通して資産リクエスト用のリンクを瞬時に作成することで、日々の暗号通貨の受け取りを簡素化できます。この合理化されたプロセスにより、迅速かつ安全に支払いを受け取り、取引の管理が容易になります。常に財務状況を把握し、シームレスな送金をお楽しみください。JPWorldPayを使えば、暗号通貨の管理はかつてないほど簡単になります。',
			two: 'JPWorldPayを使えば、資産を簡単に管理でき、購入、売却、送金など、あらゆる場面でシームレスな体験を提供します。ユーザーフレンドリーなインターフェースにより、複雑な取引も簡単に行えます。',
		},
		cta_buttons: {
			one: 'ONETEZERリンクの作成',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
